import { useStateHooks } from "../../../state"
import { TableName } from "../../../tables"
import { Ticket, useTicketLoaders } from "../../administration"
import { DeliveryStatus } from "../../deliveries"
import { PaymentStatus, usePriceOutlineHooks } from "../../operations"
import { PurchaseOrder } from "../state/types"

export const usePurchaseHooks = () => {
    const { findFiltered } = useStateHooks()
    const { getPriceOutline } = usePriceOutlineHooks()

    const ticketLoaders = useTicketLoaders()

    const isEditable = async (purchase: PurchaseOrder): Promise<boolean> => {
        const { paymentStatus, deliveryStatus } = purchase
        const { loadParentTickets } = ticketLoaders()
        const tickets = await loadParentTickets(purchase.id)
        return paymentStatus === PaymentStatus.PENDING && deliveryStatus === DeliveryStatus.PENDING && tickets.length === 0
    }

    const isEditableSync = (purchase: PurchaseOrder): boolean => {
        const { paymentStatus, deliveryStatus } = purchase
        const tickets = findFiltered(TableName.TICKETS, { parentId: purchase.id })
        return paymentStatus === PaymentStatus.PENDING && deliveryStatus === DeliveryStatus.PENDING && tickets.length === 0
    }

    const isInvoiceableSync = (purchase: PurchaseOrder): boolean => {
        const tickets = findFiltered(TableName.TICKETS, { parentId: purchase.id }) as Ticket[]
        const ticketsSubtotal = tickets.reduce((sum, ticket) => sum + ticket.subtotal, 0)
        const purchaseSubtotal = purchase ? getPriceOutline(TableName.PURCHASE_ORDERS, purchase).totalWithoutVAT : 0
        return ticketsSubtotal < purchaseSubtotal
    }

    return {
        isEditable,
        isEditableSync,
        isInvoiceableSync
    }
}

export const purchaseHelpers = {
    isFixable: (purchase: PurchaseOrder): boolean => {
        const { deliveryStatus, archived } = purchase
        return deliveryStatus === DeliveryStatus.PENDING && !archived
    },

    isArchivable: (purchase: PurchaseOrder): boolean => {
        const { paymentStatus, deliveryStatus, archived } = purchase
        return paymentStatus === PaymentStatus.PAYED && deliveryStatus === DeliveryStatus.DELIVERED && !archived
    }
}
